'use strict';

var styled = require('styled-components');
var component = require('../../Icon/component.js');
require('react');
require('../../Tooltip/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

// FIXME: add install instruction for IE 11 to support :focus-within via the polyfill https://github.com/matteobad/focus-within-polyfill
// FIXME: Test that the polyfill actually works…
const containerFocus = styled.css `
  box-shadow: 0 0 0 ${({ theme }) => theme.designTokens.controlFocusShadowSpread}
    ${({ errored, theme }) => errored ? theme.designTokens.controlErroredFocusShadowColor : theme.designTokens.controlFocusShadowColor};
`;
const Container = styled__default.default.div `
  display: block;
  position: relative;
  border-radius: ${({ theme }) => theme.designTokens.controlBorderRadius};
  box-shadow: 0 0 0 0 ${({ theme }) => theme.designTokens.controlFocusShadowColor};
  transition: box-shadow ${({ theme }) => theme.designTokens.controlFocusShadowTransitionTime}
    ${({ theme }) => theme.designTokens.controlFocusShadowTransitionFunction};

  &:focus-within,
  &.focus-within {
    ${({ disabled }) => !disabled && containerFocus}
  }

  textarea {
    resize: vertical;
  }
`;
const controlReset = styled.css `
  border: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  &:focus {
    outline: none;
  }
`;
const controlDefault = styled.css `
  display: block;
  vertical-align: middle;
  text-overflow: ellipsis;
  letter-spacing: ${({ theme }) => theme.designTokens.controlLetterSpacing};
  color: ${({ theme }) => theme.designTokens.controlTextColor};
  background: ${({ theme }) => theme.designTokens.controlBackgroundColor};
  font-family: ${({ theme }) => theme.designTokens.controlFontFamily};
  font-size: ${({ theme }) => theme.designTokens.controlFontSize};
  line-height: ${({ theme }) => theme.designTokens.controlLineHeight};
  font-weight: ${({ theme }) => theme.designTokens.controlFontWeight};
  padding: ${({ theme }) => theme.designTokens.controlPaddingY} ${({ theme }) => theme.designTokens.controlPaddingX};
  border-radius: ${({ theme }) => theme.designTokens.controlBorderRadius};
  border: ${({ theme }) => theme.designTokens.controlBorderWidth} solid
    ${({ errored, theme }) => errored ? theme.designTokens.controlErroredBorderColor : theme.designTokens.controlBorderColor};

  &::placeholder {
    color: ${({ theme }) => theme.designTokens.controlPlaceholderTextColor};
  }
`;
const controlHover = styled.css `
  border-color: ${({ theme }) => theme.designTokens.controlHoverBorderColor};
`;
const controlFocus = styled.css `
  border-color: ${({ theme }) => theme.designTokens.controlFocusBorderColor};
  box-shadow: 0 0 0 ${({ theme }) => theme.designTokens.controlFocusBorderAdditionalWidth}
    ${({ theme }) => theme.designTokens.controlFocusBorderColor};
`;
const controlErroredFocus = styled.css `
  border-color: ${({ theme }) => theme.designTokens.controlErroredBorderColor};
  box-shadow: 0 0 0 ${({ theme }) => theme.designTokens.controlFocusBorderAdditionalWidth}
    ${({ theme }) => theme.designTokens.controlErroredBorderColor};
`;
const controlDisabled = styled.css `
  border-color: ${({ theme }) => theme.designTokens.controlDisabledBorderColor};
  box-shadow: 0 0 0 ${({ theme }) => theme.designTokens.controlDisabledBorderAdditionalWidth}
    ${({ theme }) => theme.designTokens.controlDisabledBorderColor};
  background: ${({ theme }) => theme.designTokens.controlDisabledBackgroundColor};
  color: ${({ theme }) => theme.designTokens.controlDisabledTextColor};
`;
const controlWithPrefix = styled.css `
  padding-left: ${({ theme }) => theme.designTokens.controlPrefixSuffixSlotWidth};
`;
const controlWithSuffix = styled.css `
  padding-right: ${({ theme }) => theme.designTokens.controlPrefixSuffixSlotWidth};
`;
const propsToRemoveFromDOM = new Set(['prefix', 'suffix', 'errored', 'valid']);
const Control = styled__default.default.div.withConfig({
    shouldForwardProp: prop => !propsToRemoveFromDOM.has(prop),
}) `
  ${controlReset}
  ${controlDefault}
  &:hover,
  &.hover {
    ${({ disabled, errored }) => !disabled && !errored && controlHover}
  }
  &:focus,
  &.focus {
    ${({ disabled, errored }) => !disabled && (errored ? controlErroredFocus : controlFocus)}
  }
  ${({ disabled }) => disabled && controlDisabled}
  ${({ prefix }) => prefix && controlWithPrefix}
  ${({ suffix, valid }) => (suffix || valid) && controlWithSuffix}
`;
const ControlPrefixSuffix = styled__default.default.div `
  top: 50%;
  display: flex;
  position: absolute;
  align-items: center;
  pointer-events: none;
  justify-content: center;
  transform: translateY(-50%);
  color: ${({ disabled, theme }) => disabled ? theme.designTokens.controlDisabledTextColor : theme.designTokens.controlTextColor};
  ${({ placement }) => placement}: calc(${({ theme }) => theme.designTokens.controlPrefixSuffixPaddingX} + 1px);
`;
const ControlValidIcon = styled__default.default(component.Icon) `
  color: ${({ disabled, theme }) => disabled ? theme.designTokens.controlDisabledTextColor : theme.designTokens.controlValidIconColor};
`;
const Styled = {
    Container,
    Control,
    PrefixSuffix: ControlPrefixSuffix,
    ValidIcon: ControlValidIcon,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
